'use client';
import { MANIFEST_IMAGES } from '../manifest/images.js';
import { manifestResolve, getSameKeyValueMapForManifest } from './manifest.utils.js';
import { SwanAssetFolders } from '../types/enums.js';

getSameKeyValueMapForManifest(MANIFEST_IMAGES);
function getSwanImageUrl(o, m, i) {
    return manifestResolve(MANIFEST_IMAGES, o, SwanAssetFolders.IMAGES, m, i);
}

export { getSwanImageUrl };
